import { pushApi } from "~/api";

/**
 * Chuyển VAPID public key (base64url) sang Uint8Array cho pushManager.subscribe.
 */
function urlBase64ToUint8Array(base64String) {
	const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);
	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
}

/**
 * Đăng ký service worker + Web Push subscription rồi gửi lên backend.
 * Gọi sau khi đăng nhập thành công. An toàn khi gọi nhiều lần (idempotent).
 */
export async function registerWebPush() {
	try {
		if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
			return; // trình duyệt không hỗ trợ
		}

		// Cần quyền thông báo (BrowserPermission đã xin, nhưng kiểm tra lại)
		if (Notification.permission !== "granted") {
			const permission = await Notification.requestPermission();
			if (permission !== "granted") return;
		}

		const registration = await navigator.serviceWorker.register("/serviceWorker.js");
		await navigator.serviceWorker.ready;

		// Đã có subscription thì dùng lại, chưa có thì tạo mới
		let subscription = await registration.pushManager.getSubscription();

		if (!subscription) {
			const res = await pushApi.publicKey();
			const publicKey = res?.data?.publicKey;
			if (!publicKey) return;

			subscription = await registration.pushManager.subscribe({
				userVisibleOnly: true,
				applicationServerKey: urlBase64ToUint8Array(publicKey),
			});
		}

		const json = subscription.toJSON();

		await pushApi.subscribe({
			endpoint: json.endpoint,
			p256dh: json.keys?.p256dh,
			auth: json.keys?.auth,
			userAgent: navigator.userAgent,
		});
	} catch (e) {
		// Không chặn luồng app nếu push lỗi
		console.warn("registerWebPush error:", e);
	}
}

export default registerWebPush;
